const skill = [
    {
        key: 1,
        skill:"devicon-c-plain-wordmark colored"
    },
    {
        key: 2,
        skill:"devicon-cplusplus-plain colored"
    },
    {
        key: 3,
        skill:"devicon-python-plain-wordmark colored"
    },
    {
        key: 4,
        skill:"devicon-flutter-plain colored"
    },
    {
        key: 5,
        skill:"devicon-go-original-wordmark colored"
    },
    {
        key: 6,
        skill:"devicon-html5-plain-wordmark colored"
    },
    {
        key: 7,
        skill:"devicon-css3-plain-wordmark colored"
    },
    {
        key: 8,
        skill:"devicon-filezilla-plain colored"
    },
    {
        key: 9,
        skill:"devicon-javascript-plain colored"
    },
    {
        key: 10,
        skill:"devicon-jquery-plain-wordmark colored"
    },
    {
        key: 11,
        skill:"devicon-bootstrap-plain-wordmark colored"
    },
    {
        key: 12,
        skill:"devicon-nodejs-plain-wordmark colored"
    },
    {
        key: 13,
        skill:"devicon-hugo-plain-wordmark colored"
    },
    {
        key: 14,
        skill:"devicon-react-original-wordmark colored"
    },
    {
        key: 15,
        skill:"devicon-gitlab-plain-wordmark colored"
    },
    {
        key: 16,
        skill:"devicon-mysql-plain-wordmark colored"
    },
    {
        key:17,
        skill:"devicon-mongodb-plain-wordmark colored"
    },
    {
        key: 18,
        skill: "devicon-heroku-plain-wordmark colored"
    },
    {
        key: 19,
        skill:"devicon-git-plain-wordmark colored"
    },
    {
        key:20,
        skill:"devicon-github-original-wordmark colored"
    },
    {
        key:21,
        skill:"devicon-canva-original colored"
    },

    
    {
        key: 22,
        skill:"devicon-androidstudio-plain-wordmark colored"
    },
    {
        key:23,
        skill:"devicon-handlebars-plain-wordmark colored"
    },
    {
        key:24,
        skill:"devicon-jira-plain-wordmark colored"
    },
    {
        key: 25,
        skill:"devicon-linux-plain colored"
    },
    {
        key:26,
        skill:"devicon-nginx-original colored"
    },
    {
        key:27,
        skill:"devicon-dotnetcore-plain colored"
    },

     {
        key: 22,
        skill:"devicon-grafana-original-wordmark colored"
    },
    {
        key:23,
        skill:"devicon-handlebars-plain-wordmark colored"
    },
    {
        key:24,
        skill:"devicon-jira-plain-wordmark colored"
    },
    {
        key: 25,
        skill:"devicon-googlecloud-plain-wordmark colored"
    },
    {
        key:26,
        skill:"devicon-typescript-plain colored"
    },
    {
        key:27,
        skill:"devicon-xcode-plain colored"
    },
    {
        key: 28,
        skill:"devicon-docker-plain-wordmark colored"
    },
    {
        key: 29,
        skill:"devicon-dart-plain-wordmark colored"
    },
    {
        key:30,
        skill:"devicon-firebase-plain colored"
    },
]

const experience = [
    {
        key: 1,
        duration: "Oct 2021 - Present",
        position: "Full Stack Developer",
        company: "Africom Holdings"
    },
    {
        key:2,
        duration: "Oct 2021 - Present(remote)",
        position: "Full Stack Developer",
        company: "Durihub"
    },
    {
        key:3,
        duration: "June 2023 - Present (remote)",
        position: "Software Developer",
        company: "Umbai Africa"
    }
]

const data = {skill, experience}


export default data